import { render, staticRenderFns } from "./EducationSettings.vue?vue&type=template&id=07fc0df3&scoped=true"
import script from "./EducationSettings.vue?vue&type=script&lang=js"
export * from "./EducationSettings.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07fc0df3",
  null
  
)

export default component.exports